import React, { useLayoutEffect, useMemo, useReducer } from 'react';

import { NotificationManager } from '@atlas/core';

import { AccountNumbersPopup } from 'common/Popup/AccountNumbersPopup';
import AdultPopup from 'common/Popup/AdultPopup';
import BitcoinPopup from 'common/Popup/BitcoinPopup';
import ConfirmPopup from 'common/Popup/ConfirmPopup';
import { ErrorPopup } from 'common/Popup/ErrorPopup';
import FullscreenPopup from 'common/Popup/FullscreenPopup';
import GPayPopup from 'common/Popup/GPayPopup';
import { IFramePopup } from 'common/Popup/IFramePopup';
import { InstructionPopup } from 'common/Popup/InstructionPopup';
import MessagesPopup from 'common/Popup/MessagesPopup';
import MultiPopup from 'common/Popup/MultiPopup/MultiPopup';
import NotificationPopup from 'common/Popup/NotificationPopup';
import OneClickSignUp from 'common/Popup/OneClickSignUp';
import PayMayaPopup from 'common/Popup/PayMayaPopup';
import RealityCheckPopup from 'common/Popup/RealityCheck';
import RegistrationBonusPopup from 'common/Popup/RegistrationBonusPopup/RegistrationBonusPopup';
import StarsPayPopup from 'common/Popup/StarsPayPopup';
import { SuccessfulWithdrawalPopup } from 'common/Popup/SuccessfulPaymentPopup';
import SuccessPopup from 'common/Popup/SuccessPopup';
import { WithdrawalApexpayPopup } from 'common/Popup/WithdrawalApexpayPopup';
import { WithdrawalBitcoinPopup } from 'common/Popup/WithdrawalBitcoinPopup/WithdrawalBitcoinPopup';
import { WithdrawalBitcoinPopupV2 } from 'common/Popup/WithdrawalBitcoinPopup/WithdrawalBitcoinPopupV2';
import { WithdrawalCashdeskPopup } from 'common/Popup/WithdrawalCashdeskPopup/WithdrawalCashdeskPopup';
import { WithdrawalDirectaPopup } from 'common/Popup/WithdrawalDirectaPopup/WithdrawalDirectaPopup';
import { WithdrawalInterkassaPopup } from 'common/Popup/WithdrawalInterkassaPopup/WithdrawalInterkassaPopup';
import { WithdrawalPaystackPopup } from 'common/Popup/WithdrawalPaystackPopup';
import { WithdrawalPixNoEvpPopup } from 'common/Popup/WithdrawalPixPopup/WithdrawalPixNoEvpPopup';
import { WithdrawalPixPopup } from 'common/Popup/WithdrawalPixPopup/WithdrawalPixPopup';
import { WithdrawalResultPopup } from 'common/Popup/WithdrawalResultPopup';
import { WithdrawalSanalbankPopup } from 'common/Popup/WithdrawalSanalbankPopup';
import WithdrawalCodePopup from 'components/ClientProfile/Payment/Transaction/WithdrawalCodePopup';
import WithdrawalIframe from 'components/ClientProfile/Payment/Withdrawal/WithdrawalIframe';
import VerificationPopup from 'components/ClientProfile/Verification/VerificationPopup';
import ResponsibleGamingPopup from 'components/ResponsibleGamingPopup/ResponsibleGamingPopup';
import TwoFactorLogin from 'components/TwoFactorLogin/TwoFactorLogin';
import { AccountBlockedPopup } from 'src/common/Popup/AccountBlockedPopup';
import AccountToppedUpPopup from 'src/common/Popup/AccountToppedUpPopup';
import { AlternativeMethodsPopup } from 'src/common/Popup/AlternativeMethodsPopup';
import AtlasTransferPopup from 'src/common/Popup/AtlasTransferPopup';
import AtlasTransferWithdrawalPopup from 'src/common/Popup/AtlasTransferWithdrawalPopup';
import BonusActivationSuccessPopup from 'src/common/Popup/BonusActivationSuccessPopup';
import CommonSpentLimitPopup from 'src/common/Popup/CommonSpentLimitPopup';
import DepositSuccessPopup from 'src/common/Popup/DepositSuccessPopup/DepositSuccessPopup';
import { ErrorTransactionPopup } from 'src/common/Popup/ErrorTransactionPopup';
import LeaveSignupPopup from 'src/common/Popup/LeaveSignupPopup';
import { PaymentFormErrorPopup } from 'src/common/Popup/PaymentFormErrorPopup';
import PaymentLoadingPopup from 'src/common/Popup/PaymentLoadingPopup';
import PaymentsFormPopup from 'src/common/Popup/PaymentsFormPopup/PaymentsFormPopup';
import RealityCheckTimeLimitsPopup from 'src/common/Popup/RealityCheckTimeLimitsPopup';
import SpeiDepositPopup from 'src/common/Popup/SpeiPayment/SpeiDepositPopup';
import SpeiWithdrawalPopup from 'src/common/Popup/SpeiPayment/SpeiWithdrawalPopup';
import TerminalLoginPopup from 'src/common/Popup/TerminalLoginPopup/TerminalLoginPopup';
import ToastCard from 'src/common/Popup/ToastCard';
import { WithdrawalAlfacoinPopup } from 'src/common/Popup/WithdrawalAlfacoinPopup/WithdrawalAlfacoinPopup';
import { WithdrawalInteracPopup } from 'src/common/Popup/WithdrawalInteracPopup';
import WithdrawalInterkassaCardPopup from 'src/common/Popup/WithdrawalInterkassaCardPopup';
import WithdrawalInterkassaEuroPopup from 'src/common/Popup/WithdrawalInterkassaEuroPopup';
import WithdrawalKushkiPopup from 'src/common/Popup/WithdrawalKushkiPopup';
import WithdrawalMagnetarPopup from 'src/common/Popup/WithdrawalMagnetarPopup';
import WithdrawalPayretailersPopup from 'src/common/Popup/WithdrawalPayretailersPopup';
import WithdrawalProntopagaPopup from 'src/common/Popup/WithdrawalProntopagaPopup';
import WithdrawalTonderPopup from 'src/common/Popup/WithdrawalTonderPopup';
import DepositExitPopup from 'src/components/ClientProfile/Payment/Deposit/DepositExitPopup';

import NotificationsPortal from './NotificationsPortal';
import ToastStack from './ToastStack';

const NotificationsComponentsTypes = {
  WithdrawalPixNoEvp: WithdrawalPixNoEvpPopup,
  accountBlocked: AccountBlockedPopup,
  accountNumbers: AccountNumbersPopup,
  accountToppedUp: AccountToppedUpPopup,
  adultPopup: AdultPopup,
  alternativeMethods: AlternativeMethodsPopup,
  atlasTransfer: AtlasTransferPopup,
  atlasTransferWithdrawal: AtlasTransferWithdrawalPopup,
  bitcoin: BitcoinPopup,
  bonusActivationSuccess: BonusActivationSuccessPopup,
  confirm: ConfirmPopup,
  depositExitPopup: DepositExitPopup,
  depositInstruction: InstructionPopup,
  depositSuccess: DepositSuccessPopup,
  error: ErrorPopup,
  errorTransaction: ErrorTransactionPopup,
  fullscreen: FullscreenPopup,
  gpay: GPayPopup,
  iframe: IFramePopup,
  leaveSignup: LeaveSignupPopup,
  messages: MessagesPopup,
  multiPopup: MultiPopup,
  notification: NotificationPopup,
  oneClickSignUp: OneClickSignUp,
  paymaya: PayMayaPopup,
  paymentFormError: PaymentFormErrorPopup,
  paymentLoading: PaymentLoadingPopup,
  paymentsForm: PaymentsFormPopup,
  pix: StarsPayPopup,
  realityCheck: RealityCheckPopup,
  realityCheckTimeLimitsPopup: RealityCheckTimeLimitsPopup,
  registrationBonus: RegistrationBonusPopup,
  responsibleGaming: ResponsibleGamingPopup,
  speiDeposit: SpeiDepositPopup,
  speiWithdrawal: SpeiWithdrawalPopup,
  spentLimit: CommonSpentLimitPopup,
  success: SuccessPopup,
  successfulWithdrawal: SuccessfulWithdrawalPopup,
  terminalLoginPopup: TerminalLoginPopup,

  toast: ToastCard,
  twoFactorLogin: TwoFactorLogin,
  verificationPopup: VerificationPopup,
  withdrawalAlfacoin: WithdrawalAlfacoinPopup,
  withdrawalApexpay: WithdrawalApexpayPopup,
  withdrawalBitcoin: WithdrawalBitcoinPopup,
  withdrawalBitcoinV2: WithdrawalBitcoinPopupV2,
  withdrawalCashdesk: WithdrawalCashdeskPopup,
  withdrawalCodePopup: WithdrawalCodePopup,
  withdrawalDirectaPopup: WithdrawalDirectaPopup,
  withdrawalInterac: WithdrawalInteracPopup,
  withdrawalInterkassa: WithdrawalInterkassaPopup,
  withdrawalInterkassaCard: WithdrawalInterkassaCardPopup,
  withdrawalInterkassaEuro: WithdrawalInterkassaEuroPopup,
  withdrawalKushki: WithdrawalKushkiPopup,
  withdrawalMagnetar: WithdrawalMagnetarPopup,
  withdrawalPayretailers: WithdrawalPayretailersPopup,
  withdrawalPaystack: WithdrawalPaystackPopup,
  withdrawalPix: WithdrawalPixPopup,
  withdrawalPopup: WithdrawalIframe,
  withdrawalProntopaga: WithdrawalProntopagaPopup,
  withdrawalResultPopup: WithdrawalResultPopup,
  withdrawalSanalbank: WithdrawalSanalbankPopup,
  withdrawalTonder: WithdrawalTonderPopup,
};

const notificationsReducer = (state, action) => {
  switch (action.type) {
    case 'ADD':
      if (state.find(notification => notification.id === action.payload.id)) {
        return state;
      }

      return [...state, action.payload];
    case 'REMOVE':
      return state.reduce((acc, notification) => {
        if (notification.id === action.payload) {
          return acc;
        }

        return [...acc, notification];
      }, []);
    default:
      return state;
  }
};

const initialState = [];

const renderNotification = notificationData => {
  const { type, ...notificationPayload } = notificationData;

  const NotificationComponent = NotificationsComponentsTypes[type];

  if (!NotificationComponent) {
    return null;
  }

  return <NotificationComponent key={notificationData.id} {...notificationPayload} />;
};

const NotificationsContainer = () => {
  const [notifications, dispatch] = useReducer(notificationsReducer, initialState);

  useLayoutEffect(() => {
    const actionHandler = action => dispatch(action);

    NotificationManager.subscribe(actionHandler);

    return () => {
      NotificationManager.unsubscribe(actionHandler);
    };
  }, [dispatch]);

  const { popups, toasts } = useMemo(() => {
    const partitioned = { popups: [], toasts: [] };

    notifications.forEach(notification => {
      if (notification.kind === 'toast') {
        partitioned.toasts.push(notification);
      } else {
        partitioned.popups.push(notification);
      }
    });

    return partitioned;
  }, [notifications]);

  const PopupComponents = useMemo(() => popups.map(renderNotification), [popups]);

  return (
    <>
      <NotificationsPortal className="notifications-container">
        {PopupComponents}
      </NotificationsPortal>
      <ToastStack items={toasts} renderToast={renderNotification} />
    </>
  );
};

export default NotificationsContainer;
